/* eslint-disable jsx-a11y/anchor-is-valid, no-underscore-dangle */
import React from 'react';
import _ from 'lodash';

const PRIVACY_MANAGER_ID = 165581;

const clickHandler = () => {
  const loadPrivacyManagerModal = _.get(window, '_sp_.loadPrivacyManagerModal', () => {});
  loadPrivacyManagerModal(PRIVACY_MANAGER_ID);
}

const NGNFooter = () => (
  <footer className="GlobalFooter">
    <div className="Container GlobalFooter-container">
      <div className="GlobalFooter-section GlobalFooter-section--tertiary">
        <div className="GlobalFooter-companyInfo">
          <p>
            © News Group Newspapers Limited.&nbsp;<br />
            Registered in England No. 679215.&nbsp;Registered office: 1 London Bridge Street, SE1 9GF.
          </p>
        </div>
        <ul className="GlobalFooter-list GlobalFooter-list--small">
          <li>
            <a href="https://www.newsprivacy.co.uk/single/">Privacy &amp; cookie policy</a>
          </li>
          <li>
            <a href="http://www.newslicensing.co.uk" >Licensing</a>
          </li>
          <li>
            <a href="#" onClick={clickHandler} className="optanon-toggle-display">Cookie settings</a>
          </li>
          <li>
            <a href="https://www.thesun.co.uk/terms-and-conditions/">Terms and conditions</a>
          </li>
        </ul>
      </div>
    </div>
  </footer>
);

export default NGNFooter;
